const reasons = {
  inDelay: 'serviço em atraso',
  inDelayMany: 'serviços em atraso',
  notDone: 'serviço obrigatório não realizado',
  notDoneMany: 'serviços obrigatórios não realizados',
  hasActionsOpenedOrOverdue: 'serviço com ações abertas ou vencidas',
  hasActionsOpenedOrOverdueMany: 'serviços com ações abertas ou vencidas',
  hasNoServices: 'Não possui nenhum serviço',
}

export default reasons;
